import { gradientTextStyles } from '@/src/card-linking/components/colors'
import { CardPreview } from '@/src/card-linking/components/CardPreview'
import {
    defaultBodyText,
    defaultDivWrapper,
    defaultHeader,
    disclaimerText,
    standardPrimaryButton,
    standardPrimaryButtonOnMouseEnter,
    standardPrimaryButtonOnMouseLeave,
    underlinedBoldBodyText,
} from '@/src/card-linking/components/iframeStyles'

interface CardLinkEnrolledCardsProps {
    enrolledCardsData: any // @TODO add proper type
    handleActivateGift: Function
    handleShowPaymentMethodForm: Function
    handleSelectCard: Function
}

export const CardLinkEnrolledCards = ({
    enrolledCardsData,
    handleActivateGift,
    handleShowPaymentMethodForm,
    handleSelectCard,
}: CardLinkEnrolledCardsProps) => {
    return (
        <>
            <div style={defaultDivWrapper}>
                <h2 style={defaultHeader}>
                    <span style={gradientTextStyles}>Activate</span> to your
                    Visa, Mastercard, or Amex
                </h2>
                <p style={defaultBodyText}>
                    Link your gift to a card you have previously registered.
                    Easy and revolutionary!
                </p>
                {enrolledCardsData instanceof Array &&
                    enrolledCardsData.map((card) => {
                        return (
                            <div style={{ display: 'flex' }} key={card.id}>
                                <input
                                    type="radio"
                                    id={card.id}
                                    name={'payment'}
                                    onChange={(e) => {
                                        handleSelectCard(card)
                                    }}
                                    style={{ cursor: 'pointer' }}
                                />
                                <CardPreview
                                    cardId={card.id}
                                    cardNetwork={card.brand}
                                    cardLastFour={card.card_last_four}
                                />
                            </div>
                        )
                    })}
                <button
                    onClick={(e) => {
                        e.preventDefault()
                        handleShowPaymentMethodForm()
                    }}
                    style={{
                        ...underlinedBoldBodyText,
                        marginTop: 10,
                        marginBottom: 10,
                    }}
                >
                    Add new credit or debit card
                </button>
                <div>
                    <button
                        style={standardPrimaryButton}
                        onMouseEnter={(e) => {
                            standardPrimaryButtonOnMouseEnter(e)
                        }}
                        onMouseLeave={(e) => {
                            standardPrimaryButtonOnMouseLeave(e)
                        }}
                        onClick={(e) => {
                            e.preventDefault()
                            handleActivateGift()
                        }}
                    >
                        Activate &#x2192;
                    </button>
                    <p style={disclaimerText}>
                        Not all cards are eligible and not all transactions can
                        be monitored. For debit cards, run transaction as
                        credit, do not use PIS. See terms of service for full
                        card and transaction eligibility details.
                    </p>
                </div>
            </div>
        </>
    )
}

export default CardLinkEnrolledCards
